import { useEffect } from 'react';
import { getScrollParents } from '@floating-ui/react-dom';
export function useUpdateOnScroll(ref, handler, eventType) {
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const parents = getScrollParents(ref.current);
        parents.forEach(parent => {
            parent.addEventListener(eventType, handler);
        });
        return () => {
            parents.forEach(parent => {
                parent.removeEventListener(eventType, handler);
            });
        };
    }, [ref, eventType, handler]);
}
//# sourceMappingURL=useUpdateOnScroll.js.map